import * as actionTypes from './actionTypes';

const initialState = {
  abandonments: [],
  loading: false,
  error: null,
  sendingReminders: {},
  lastFetched: null
};

export default function cartAbandonmentReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_CART_ABANDONMENTS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
      
    case actionTypes.FETCH_CART_ABANDONMENTS_SUCCESS:
      return {
        ...state,
        loading: false,
        abandonments: action.payload,
        lastFetched: new Date().toISOString()
      };
      
    case actionTypes.FETCH_CART_ABANDONMENTS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
      
    case actionTypes.SEND_CART_REMINDER_REQUEST:
      return {
        ...state,
        sendingReminders: {
          ...state.sendingReminders,
          [action.payload.cartId]: true
        }
      };
      
    case actionTypes.SEND_CART_REMINDER_SUCCESS:
      return {
        ...state,
        sendingReminders: {
          ...state.sendingReminders,
          [action.payload.cartId]: false
        },
        abandonments: state.abandonments.map(abandonment => 
          abandonment.cartId === action.payload.cartId 
            ? { ...abandonment, lastReminderSent: new Date().toISOString() }
            : abandonment
        )
      };
      
    case actionTypes.SEND_CART_REMINDER_FAILURE:
      return {
        ...state,
        sendingReminders: {
          ...state.sendingReminders,
          [action.payload.cartId]: false
        }
      };
      
    default:
      return state;
  }
}